// U.S. Naturalization Test - 128 Civics Questions and Answers (2025 Version)
// Official questions from USCIS for the naturalization test effective October 20, 2025

export const naturalizationQuestions = [
  // A: Principles of American Government (15 questions)
  {
    id: 1,
    category: "Principles of American Government",
    question: "What is the form of government of the United States?",
    answer: "Republic; Constitution-based federal republic; Representative democracy",
    alternativeAnswers: ["Republic", "Constitution-based federal republic", "Representative democracy"]
  },
  {
    id: 2,
    category: "Principles of American Government",
    question: "What is the supreme law of the land?",
    answer: "(U.S.) Constitution",
    alternativeAnswers: ["Constitution", "U.S. Constitution", "the Constitution"]
  },
  {
    id: 3,
    category: "Principles of American Government",
    question: "Name one thing the U.S. Constitution does.",
    answer: "Forms the government; Defines powers of government; Defines the parts of government; Protects the rights of the people",
    alternativeAnswers: ["Forms the government", "Defines powers of government", "Defines the parts of government", "Protects the rights of the people"]
  },
  {
    id: 4,
    category: "Principles of American Government",
    question: "The U.S. Constitution starts with the words \"We the People.\" What does \"We the People\" mean?",
    answer: "Self-government; Popular sovereignty; Consent of the governed; People should govern themselves; (Example of) social contract",
    alternativeAnswers: ["Self-government", "Popular sovereignty", "Consent of the governed", "People should govern themselves", "social contract"]
  },
  {
    id: 5,
    category: "Principles of American Government",
    question: "How are changes made to the U.S. Constitution?",
    answer: "Amendments; The amendment process",
    alternativeAnswers: ["Amendments", "The amendment process"]
  },
  {
    id: 6,
    category: "Principles of American Government", 
    question: "What does the Bill of Rights protect?",
    answer: "(The basic) rights of Americans; (The basic) rights of people living in the United States",
    alternativeAnswers: ["The basic rights of Americans", "The basic rights of people living in the United States", "rights of Americans", "rights of people living in the United States"]
  },
  {
    id: 7,
    category: "Principles of American Government",
    question: "How many amendments does the U.S. Constitution have?",
    answer: "Twenty-seven (27)",
    alternativeAnswers: ["27", "twenty-seven", "Twenty-seven"]
  },
  {
    id: 8,
    category: "Principles of American Government",
    question: "Why is the Declaration of Independence important?",
    answer: "It says America is free from British control; It says all people are created equal; It identifies inherent rights; It identifies individual freedoms",
    alternativeAnswers: ["It says America is free from British control", "It says all people are created equal", "It identifies inherent rights", "It identifies individual freedoms"]
  },
  {
    id: 9,
    category: "Principles of American Government",
    question: "What founding document said the American colonies were free from Britain?",
    answer: "Declaration of Independence",
    alternativeAnswers: ["Declaration of Independence"]
  },
  {
    id: 10,
    category: "Principles of American Government",
    question: "Name two important ideas from the Declaration of Independence and the U.S. Constitution.",
    answer: "Equality; Liberty; Social contract; Natural rights; Limited government; Self-government",
    alternativeAnswers: ["Equality", "Liberty", "Social contract", "Natural rights", "Limited government", "Self-government"]
  },
  {
    id: 11,
    category: "Principles of American Government",
    question: "The words \"Life, Liberty, and the pursuit of Happiness\" are in what founding document?",
    answer: "Declaration of Independence",
    alternativeAnswers: ["Declaration of Independence"]
  },
  {
    id: 12,
    category: "Principles of American Government",
    question: "What is the economic system of the United States?",
    answer: "Capitalism; Free market economy",
    alternativeAnswers: ["Capitalism", "Free market economy"],
    specialConsideration: true // 65/20 special consideration question
  },
  {
    id: 13,
    category: "Principles of American Government",
    question: "What is the rule of law?",
    answer: "Everyone must follow the law; Leaders must obey the law; Government must obey the law; No one is above the law",
    alternativeAnswers: ["Everyone must follow the law", "Leaders must obey the law", "Government must obey the law", "No one is above the law"]
  },
  {
    id: 14,
    category: "Principles of American Government",
    question: "Many documents influenced the U.S. Constitution. Name one.",
    answer: "Declaration of Independence; Articles of Confederation; Federalist Papers; Anti-Federalist Papers; Virginia Declaration of Rights; Fundamental Orders of Connecticut; Mayflower Compact; Iroquois Great Law of Peace",
    alternativeAnswers: ["Declaration of Independence", "Articles of Confederation", "Federalist Papers", "Anti-Federalist Papers", "Virginia Declaration of Rights", "Fundamental Orders of Connecticut", "Mayflower Compact", "Iroquois Great Law of Peace"]
  },
  {
    id: 15,
    category: "Principles of American Government",
    question: "There are three branches of government. Why?",
    answer: "So one part does not become too powerful; Checks and balances; Separation of powers",
    alternativeAnswers: ["So one part does not become too powerful", "Checks and balances", "Separation of powers"]
  },

  // B: System of Government (47 questions)
  {
    id: 16,
    category: "System of Government",
    question: "Name the three branches of government.",
    answer: "Legislative, executive, and judicial; Congress, president, and the courts",
    alternativeAnswers: ["Legislative, executive, and judicial", "Congress, president, and the courts", "legislative", "executive", "judicial", "Congress", "president", "the courts"]
  },
  {
    id: 17,
    category: "System of Government",
    question: "The President of the United States is in charge of which branch of government?",
    answer: "Executive branch",
    alternativeAnswers: ["Executive branch", "executive"]
  },
  {
    id: 18,
    category: "System of Government",
    question: "What part of the federal government writes laws?",
    answer: "(U.S.) Congress; (U.S. or national) legislature; Legislative branch",
    alternativeAnswers: ["Congress", "U.S. Congress", "legislature", "Legislative branch", "national legislature"]
  },
  {
    id: 19,
    category: "System of Government",
    question: "What are the two parts of the U.S. Congress?",
    answer: "Senate and House (of Representatives)",
    alternativeAnswers: ["Senate and House of Representatives", "Senate and House", "the Senate and House of Representatives"]
  },
  {
    id: 20,
    category: "System of Government",
    question: "Name one power of the U.S. Congress.",
    answer: "Writes laws; Declares war; Makes the federal budget",
    alternativeAnswers: ["Writes laws", "Declares war", "Makes the federal budget"]
  },
  {
    id: 21,
    category: "System of Government",
    question: "How many U.S. senators are there?",
    answer: "One hundred (100)",
    alternativeAnswers: ["100", "one hundred", "One hundred"]
  },
  {
    id: 22,
    category: "System of Government",
    question: "How long is a term for a U.S. senator?",
    answer: "Six (6) years",
    alternativeAnswers: ["6 years", "six years", "Six years"]
  },
  {
    id: 23,
    category: "System of Government",
    question: "Who is one of your state's U.S. senators now?",
    answer: "Answers will vary. [District of Columbia residents and residents of U.S. territories should answer that D.C. (or the territory where the applicant lives) has no U.S. senators.]",
    alternativeAnswers: ["Answers will vary by state"]
  },
  {
    id: 24,
    category: "System of Government",
    question: "How many voting members are in the House of Representatives?",
    answer: "Four hundred thirty-five (435)",
    alternativeAnswers: ["435", "four hundred thirty-five", "Four hundred thirty-five"]
  },
  {
    id: 25,
    category: "System of Government",
    question: "How long is a term for a member of the House of Representatives?",
    answer: "Two (2) years",
    alternativeAnswers: ["2 years", "two years", "Two years"]
  },
  {
    id: 26,
    category: "System of Government",
    question: "Why do U.S. representatives serve shorter terms than U.S. senators?",
    answer: "To more closely follow public opinion",
    alternativeAnswers: ["To more closely follow public opinion"]
  },
  {
    id: 27,
    category: "System of Government",
    question: "How many senators does each state have?",
    answer: "Two (2)",
    alternativeAnswers: ["2", "two", "Two"]
  },
  {
    id: 28,
    category: "System of Government",
    question: "Why does each state have two senators?",
    answer: "Equal representation (for small states); The Great Compromise (Connecticut Compromise)",
    alternativeAnswers: ["Equal representation for small states", "The Great Compromise", "Connecticut Compromise", "Equal representation"]
  },
  {
    id: 29,
    category: "System of Government",
    question: "Name your U.S. representative.",
    answer: "Answers will vary. [Residents of territories with nonvoting Delegates or Resident Commissioners may provide the name of that Delegate or Commissioner. Also acceptable is any statement that the territory has no (voting) representatives in Congress.]",
    alternativeAnswers: ["Answers will vary by district"]
  },
  {
    id: 30,
    category: "System of Government",
    question: "What is the name of the Speaker of the House of Representatives now?",
    answer: "Mike Johnson",
    alternativeAnswers: ["Mike Johnson"]
  },
  {
    id: 31,
    category: "System of Government",
    question: "Who does a U.S. senator represent?",
    answer: "Citizens of their state; People of their state",
    alternativeAnswers: ["Citizens of their state", "People of their state"]
  },
  {
    id: 32,
    category: "System of Government",
    question: "Who elects U.S. senators?",
    answer: "Citizens from their state",
    alternativeAnswers: ["Citizens from their state"]
  },
  {
    id: 33,
    category: "System of Government",
    question: "Who does a member of the House of Representatives represent?",
    answer: "Citizens in their (congressional) district; People from their (congressional) district",
    alternativeAnswers: ["Citizens in their district", "People from their district", "Citizens in their congressional district", "People from their congressional district"]
  },
  {
    id: 34,
    category: "System of Government",
    question: "Who elects members of the House of Representatives?",
    answer: "Citizens from their (congressional) district",
    alternativeAnswers: ["Citizens from their district", "Citizens from their congressional district"]
  },
  {
    id: 35,
    category: "System of Government",
    question: "Some states have more representatives than other states. Why?",
    answer: "(Because of) the state's population; (Because) they have more people; (Because) some states have more people",
    alternativeAnswers: ["Because of the state's population", "Because they have more people", "Because some states have more people"]
  },
  {
    id: 36,
    category: "System of Government",
    question: "The President of the United States is elected for how many years?",
    answer: "Four (4) years",
    alternativeAnswers: ["4 years", "four years", "Four years"]
  },
  {
    id: 37,
    category: "System of Government",
    question: "The President of the United States can serve only two terms. Why?",
    answer: "(Because of) the 22nd Amendment; To keep the president from becoming too powerful",
    alternativeAnswers: ["Because of the 22nd Amendment", "To keep the president from becoming too powerful", "22nd Amendment"]
  },
  {
    id: 38,
    category: "System of Government",
    question: "What is the name of the President of the United States now?",
    answer: "Donald Trump; Donald J. Trump",
    alternativeAnswers: ["Donald Trump", "Donald J. Trump", "Trump"]
  },
  {
    id: 39,
    category: "System of Government",
    question: "What is the name of the Vice President of the United States now?",
    answer: "JD Vance; J.D. Vance",
    alternativeAnswers: ["JD Vance", "J.D. Vance", "Vance"]
  },
  {
    id: 40,
    category: "System of Government",
    question: "If the president can no longer serve, who becomes president?",
    answer: "The Vice President (of the United States)",
    alternativeAnswers: ["The Vice President", "Vice President"]
  },
  {
    id: 41,
    category: "System of Government",
    question: "Name one power of the president.",
    answer: "Signs bills into law; Vetoes bills; Enforces laws; Commander in Chief (of the military); Chief diplomat; Appoints federal judges",
    alternativeAnswers: ["Signs bills into law", "Vetoes bills", "Enforces laws", "Commander in Chief", "Chief diplomat", "Appoints federal judges"]
  },
  {
    id: 42,
    category: "System of Government",
    question: "Who is Commander in Chief of the U.S. military?",
    answer: "The President (of the United States)",
    alternativeAnswers: ["The President", "President"]
  },
  {
    id: 43,
    category: "System of Government",
    question: "Who signs bills to become laws?",
    answer: "The President (of the United States)",
    alternativeAnswers: ["The President", "President"]
  },
  {
    id: 44,
    category: "System of Government",
    question: "Who vetoes bills?",
    answer: "The President (of the United States)",
    alternativeAnswers: ["The President", "President"]
  },
  {
    id: 45,
    category: "System of Government",
    question: "Who appoints federal judges?",
    answer: "The President (of the United States)",
    alternativeAnswers: ["The President", "President"]
  },
  {
    id: 46,
    category: "System of Government",
    question: "The executive branch has many parts. Name one.",
    answer: "President (of the United States); Cabinet; Federal departments and agencies",
    alternativeAnswers: ["President", "Cabinet", "Federal departments and agencies"]
  },
  {
    id: 47,
    category: "System of Government",
    question: "What does the President's Cabinet do?",
    answer: "Advises the President (of the United States)",
    alternativeAnswers: ["Advises the President"]
  },
  {
    id: 48,
    category: "System of Government",
    question: "What are two Cabinet-level positions?",
    answer: "Attorney General; Secretary of Agriculture; Secretary of Commerce; Secretary of Education; Secretary of Energy; Secretary of Health and Human Services; Secretary of Homeland Security; Secretary of Housing and Urban Development; Secretary of the Interior; Secretary of Labor; Secretary of State; Secretary of Transportation; Secretary of the Treasury; Secretary of Veterans Affairs; Secretary of War; Vice-President; Administrator of the Environmental Protection Agency; Administrator of the Small Business Administration; Director of the Central Intelligence Agency; Director of the Office of Management and Budget; Director of National Intelligence; United States Trade Representative",
    alternativeAnswers: ["Attorney General", "Secretary of Agriculture", "Secretary of Commerce", "Secretary of Education", "Secretary of Energy", "Secretary of Health and Human Services", "Secretary of Homeland Security", "Secretary of Housing and Urban Development", "Secretary of the Interior", "Secretary of Labor", "Secretary of State", "Secretary of Transportation", "Secretary of the Treasury", "Secretary of Veterans Affairs", "Secretary of War", "Vice-President", "Administrator of the Environmental Protection Agency", "Administrator of the Small Business Administration", "Director of the Central Intelligence Agency", "Director of the Office of Management and Budget", "Director of National Intelligence", "United States Trade Representative"]
  },
  {
    id: 49,
    category: "System of Government",
    question: "Why is the Electoral College important?",
    answer: "It decides who is elected president; It provides a compromise between the popular election of the president and congressional selection",
    alternativeAnswers: ["It decides who is elected president", "It provides a compromise between the popular election of the president and congressional selection"]
  },
  {
    id: 50,
    category: "System of Government",
    question: "What is one part of the judicial branch?",
    answer: "Supreme Court; Federal Courts",
    alternativeAnswers: ["Supreme Court", "Federal Courts"]
  },
  {
    id: 51,
    category: "System of Government",
    question: "What does the judicial branch do?",
    answer: "Reviews laws; Explains laws; Resolves disputes (disagreements) about the law; Decides if a law goes against the (U.S.) Constitution",
    alternativeAnswers: ["Reviews laws", "Explains laws", "Resolves disputes about the law", "Decides if a law goes against the Constitution"]
  },
  {
    id: 52,
    category: "System of Government",
    question: "What is the highest court in the United States?",
    answer: "Supreme Court",
    alternativeAnswers: ["Supreme Court"]
  },
  {
    id: 53,
    category: "System of Government",
    question: "How many seats are on the Supreme Court?",
    answer: "Nine (9)",
    alternativeAnswers: ["9", "nine", "Nine"]
  },
  {
    id: 54,
    category: "System of Government",
    question: "How many Supreme Court justices are usually needed to decide a case?",
    answer: "Five (5)",
    alternativeAnswers: ["5", "five", "Five"]
  },
  {
    id: 55,
    category: "System of Government",
    question: "How long do Supreme Court justices serve?",
    answer: "(For) life; Lifetime appointment; (Until) retirement",
    alternativeAnswers: ["For life", "Lifetime appointment", "Until retirement", "life"]
  },
  {
    id: 56,
    category: "System of Government",
    question: "Supreme Court justices serve for life. Why?",
    answer: "To be independent (of politics); To limit outside (political) influence",
    alternativeAnswers: ["To be independent of politics", "To limit outside political influence"]
  },
  {
    id: 57,
    category: "System of Government",
    question: "Who is the Chief Justice of the United States now?",
    answer: "John Roberts; John G. Roberts Jr.",
    alternativeAnswers: ["John Roberts", "John G. Roberts Jr.", "Roberts"]
  },
  {
    id: 58,
    category: "System of Government",
    question: "Name one power that is only for the federal government.",
    answer: "Print paper money; Mint coins; Declare war; Create an army; Make treaties; Set foreign policy",
    alternativeAnswers: ["Print paper money", "Mint coins", "Declare war", "Create an army", "Make treaties", "Set foreign policy"]
  },
  {
    id: 59,
    category: "System of Government",
    question: "Name one power that is only for the states.",
    answer: "Provide schooling and education; Provide protection (police); Provide safety (fire departments); Give a driver's license; Approve zoning and land use",
    alternativeAnswers: ["Provide schooling and education", "Provide protection", "Provide safety", "Give a driver's license", "Approve zoning and land use"]
  },
  {
    id: 60,
    category: "System of Government",
    question: "What is the purpose of the 10th Amendment?",
    answer: "(It states that the) powers not given to the federal government belong to the states or to the people.",
    alternativeAnswers: ["Powers not given to the federal government belong to the states or to the people"]
  },
  {
    id: 61,
    category: "System of Government",
    question: "Who is the governor of your state now?",
    answer: "Answers will vary. [District of Columbia residents should answer that D.C. does not have a governor.]",
    alternativeAnswers: ["Answers will vary by state"]
  },
  {
    id: 62,
    category: "System of Government",
    question: "What is the capital of your state?",
    answer: "Answers will vary. [District of Columbia residents should answer that D.C. is not a state and does not have a capital. Residents of U.S. territories should name the capital of the territory.]",
    alternativeAnswers: ["Answers will vary by state"]
  },

  // C: Rights and Responsibilities (10 questions)
  {
    id: 63,
    category: "Rights and Responsibilities",
    question: "There are four amendments to the U.S. Constitution about who can vote. Describe one of them.",
    answer: "Citizens eighteen (18) and older (can vote); You don't have to pay (a poll tax) to vote; Any citizen can vote. (Women and men can vote.); A male citizen of any race (can vote)",
    alternativeAnswers: ["Citizens eighteen and older can vote", "You don't have to pay a poll tax to vote", "Any citizen can vote", "Women and men can vote", "A male citizen of any race can vote"]
  },
  {
    id: 64,
    category: "Rights and Responsibilities",
    question: "Who can vote in federal elections, run for federal office, and serve on a jury in the United States?",
    answer: "Citizens; Citizens of the United States; U.S. citizens",
    alternativeAnswers: ["Citizens", "Citizens of the United States", "U.S. citizens"]
  },
  {
    id: 65,
    category: "Rights and Responsibilities",
    question: "What are three rights of everyone living in the United States?",
    answer: "Freedom of expression; Freedom of speech; Freedom of assembly; Freedom to petition the government; Freedom of religion; The right to bear arms",
    alternativeAnswers: ["Freedom of expression", "Freedom of speech", "Freedom of assembly", "Freedom to petition the government", "Freedom of religion", "The right to bear arms"]
  },
  {
    id: 66,
    category: "Rights and Responsibilities",
    question: "What do we show loyalty to when we say the Pledge of Allegiance?",
    answer: "The United States; The flag",
    alternativeAnswers: ["The United States", "The flag"],
    specialConsideration: true // 65/20 special consideration question
  },
  {
    id: 67,
    category: "Rights and Responsibilities",
    question: "Name two promises that new citizens make in the Oath of Allegiance.",
    answer: "Give up loyalty to other countries; Defend the (U.S.) Constitution; Obey the laws of the United States; Serve in the military (if needed); Serve (help, do important work for) the nation (if needed); Be loyal to the United States",
    alternativeAnswers: ["Give up loyalty to other countries", "Defend the Constitution", "Obey the laws of the United States", "Serve in the military if needed", "Serve the nation if needed", "Be loyal to the United States"]
  },
  {
    id: 68,
    category: "Rights and Responsibilities",
    question: "How can people become United States citizens?",
    answer: "Be born in the United States, under the conditions set by the 14th Amendment; Naturalize; Derive citizenship (under conditions set by Congress)",
    alternativeAnswers: ["Be born in the United States", "Naturalize", "Derive citizenship"]
  },
  {
    id: 69,
    category: "Rights and Responsibilities",
    question: "What are two examples of civic participation in the United States?",
    answer: "Vote; Run for office; Join a political party; Help with a campaign; Join a civic group; Join a community group; Give an elected official your opinion (on an issue); Contact elected officials; Support or oppose an issue or policy; Write to a newspaper",
    alternativeAnswers: ["Vote", "Run for office", "Join a political party", "Help with a campaign", "Join a civic group", "Join a community group", "Give an elected official your opinion", "Contact elected officials", "Support or oppose an issue or policy", "Write to a newspaper"]
  },
  {
    id: 70,
    category: "Rights and Responsibilities",
    question: "What is one way Americans can serve their country?",
    answer: "Vote; Pay taxes; Obey the law; Serve in the military; Run for office; Work for local, state, or federal government",
    alternativeAnswers: ["Vote", "Pay taxes", "Obey the law", "Serve in the military", "Run for office", "Work for government"]
  },
  {
    id: 71,
    category: "Rights and Responsibilities",
    question: "Why is it important to pay federal taxes?",
    answer: "Required by law; All people pay to fund the federal government; Required by the (U.S.) Constitution (16th Amendment); Civic duty",
    alternativeAnswers: ["Required by law", "All people pay to fund the federal government", "Required by the Constitution", "Civic duty"]
  },
  {
    id: 72,
    category: "Rights and Responsibilities",
    question: "It is important for all men age 18 through 25 to register for the Selective Service. Name one reason why.",
    answer: "Required by law; Civic duty; Makes the draft fair, if needed",
    alternativeAnswers: ["Required by law", "Civic duty", "Makes the draft fair, if needed"]
  },

  // A: Colonial Period and Independence (16 questions)
  {
    id: 73,
    category: "Colonial Period and Independence",
    question: "The colonists came to America for many reasons. Name one.",
    answer: "Freedom; Political liberty; Religious freedom; Economic opportunity; Escape persecution",
    alternativeAnswers: ["Freedom", "Political liberty", "Religious freedom", "Economic opportunity", "Escape persecution"]
  },
  {
    id: 74,
    category: "Colonial Period and Independence",
    question: "Who lived in America before the Europeans arrived?",
    answer: "American Indians; Native Americans",
    alternativeAnswers: ["American Indians", "Native Americans"]
  },
  {
    id: 75,
    category: "Colonial Period and Independence",
    question: "What group of people was taken and sold as slaves?",
    answer: "Africans; People from Africa",
    alternativeAnswers: ["Africans", "People from Africa"]
  },
  {
    id: 76,
    category: "Colonial Period and Independence",
    question: "What war did the Americans fight to win independence from Britain?",
    answer: "American Revolution; The (American) Revolutionary War; War for (American) Independence",
    alternativeAnswers: ["American Revolution", "Revolutionary War", "War for Independence"]
  },
  {
    id: 77,
    category: "Colonial Period and Independence",
    question: "Name one reason why the Americans declared independence from Britain.",
    answer: "High taxes; Taxation without representation; British soldiers stayed in Americans' houses (boarding, quartering); They did not have self-government; Boston Massacre; Boston Tea Party (Tea Act); Stamp Act; Sugar Act; Townshend Acts; Intolerable (Coercive) Acts",
    alternativeAnswers: ["High taxes", "Taxation without representation", "British soldiers stayed in Americans' houses", "They did not have self-government", "Boston Massacre", "Boston Tea Party", "Stamp Act", "Sugar Act", "Townshend Acts", "Intolerable Acts"]
  },
  {
    id: 78,
    category: "Colonial Period and Independence",
    question: "Who wrote the Declaration of Independence?",
    answer: "(Thomas) Jefferson",
    alternativeAnswers: ["Thomas Jefferson", "Jefferson"],
    specialConsideration: true // 65/20 special consideration question
  },
  {
    id: 79,
    category: "Colonial Period and Independence",
    question: "When was the Declaration of Independence adopted?",
    answer: "July 4, 1776",
    alternativeAnswers: ["July 4, 1776"]
  },
  {
    id: 80,
    category: "Colonial Period and Independence",
    question: "The American Revolution had many important events. Name one.",
    answer: "(Battle of) Bunker Hill; Declaration of Independence; Washington Crossing the Delaware (Battle of Trenton); (Battle of) Saratoga; Valley Forge (Encampment); (Battle of) Yorktown (British surrender at Yorktown)",
    alternativeAnswers: ["Battle of Bunker Hill", "Declaration of Independence", "Washington Crossing the Delaware", "Battle of Trenton", "Battle of Saratoga", "Valley Forge", "Battle of Yorktown"]
  },
  {
    id: 81,
    category: "Colonial Period and Independence",
    question: "There were 13 original states. Name five.",
    answer: "New Hampshire; Massachusetts; Rhode Island; Connecticut; New York; New Jersey; Pennsylvania; Delaware; Maryland; Virginia; North Carolina; South Carolina; Georgia",
    alternativeAnswers: ["New Hampshire", "Massachusetts", "Rhode Island", "Connecticut", "New York", "New Jersey", "Pennsylvania", "Delaware", "Maryland", "Virginia", "North Carolina", "South Carolina", "Georgia"]
  },
  {
    id: 82,
    category: "Colonial Period and Independence",
    question: "What founding document was written in 1787?",
    answer: "(U.S.) Constitution",
    alternativeAnswers: ["Constitution", "U.S. Constitution"]
  },
  {
    id: 83,
    category: "Colonial Period and Independence",
    question: "The Federalist Papers supported the passage of the U.S. Constitution. Name one of the writers.",
    answer: "(James) Madison; (Alexander) Hamilton; (John) Jay; Publius",
    alternativeAnswers: ["James Madison", "Alexander Hamilton", "John Jay", "Publius", "Madison", "Hamilton", "Jay"]
  },
  {
    id: 84,
    category: "Colonial Period and Independence",
    question: "Why were the Federalist Papers important?",
    answer: "They helped people understand the (U.S.) Constitution; They supported passing the (U.S.) Constitution",
    alternativeAnswers: ["They helped people understand the Constitution", "They supported passing the Constitution"]
  },
  {
    id: 85,
    category: "Colonial Period and Independence",
    question: "Benjamin Franklin is famous for many things. Name one.",
    answer: "Founded the first free public libraries; First Postmaster General of the United States; Helped write the Declaration of Independence; Inventor; U.S. diplomat",
    alternativeAnswers: ["Founded the first free public libraries", "First Postmaster General", "Helped write the Declaration of Independence", "Inventor", "U.S. diplomat"]
  },
  {
    id: 86,
    category: "Colonial Period and Independence",
    question: "George Washington is famous for many things. Name one.",
    answer: "\"Father of Our Country\"; First president of the United States; General of the Continental Army; President of the Constitutional Convention",
    alternativeAnswers: ["Father of Our Country", "First president", "General of the Continental Army", "President of the Constitutional Convention"],
    specialConsideration: true // 65/20 special consideration question
  },
  {
    id: 87,
    category: "Colonial Period and Independence",
    question: "Thomas Jefferson is famous for many things. Name one.",
    answer: "Writer of the Declaration of Independence; Third president of the United States; Doubled the size of the United States (Louisiana Purchase); First Secretary of State; Founded the University of Virginia; Writer of the Virginia Statute on Religious Freedom",
    alternativeAnswers: ["Writer of the Declaration of Independence", "Third president", "Louisiana Purchase", "First Secretary of State", "Founded the University of Virginia", "Writer of the Virginia Statute on Religious Freedom"]
  },
  {
    id: 88,
    category: "Colonial Period and Independence",
    question: "James Madison is famous for many things. Name one.",
    answer: "\"Father of the Constitution\"; Fourth president of the United States; President during the War of 1812; One of the writers of the Federalist Papers",
    alternativeAnswers: ["Father of the Constitution", "Fourth president", "President during the War of 1812", "One of the writers of the Federalist Papers"]
  },
  {
    id: 89,
    category: "Colonial Period and Independence",
    question: "Alexander Hamilton is famous for many things. Name one.",
    answer: "First Secretary of the Treasury; One of the writers of the Federalist Papers; Helped establish the First Bank of the United States; Aide to General George Washington; Member of the Continental Congress",
    alternativeAnswers: ["First Secretary of the Treasury", "One of the writers of the Federalist Papers", "Helped establish the First Bank of the United States", "Aide to General George Washington", "Member of the Continental Congress"]
  },

  // B: 1800s (9 questions)
  {
    id: 90,
    category: "1800s",
    question: "What territory did the United States buy from France in 1803?",
    answer: "Louisiana Territory; Louisiana",
    alternativeAnswers: ["Louisiana Territory", "Louisiana"]
  },
  {
    id: 91,
    category: "1800s",
    question: "Name one war fought by the United States in the 1800s.",
    answer: "War of 1812; Mexican-American War; Civil War; Spanish-American War",
    alternativeAnswers: ["War of 1812", "Mexican-American War", "Civil War", "Spanish-American War"]
  },
  {
    id: 92,
    category: "1800s",
    question: "Name the U.S. war between the North and the South.",
    answer: "The Civil War",
    alternativeAnswers: ["Civil War", "The Civil War"]
  },
  {
    id: 93,
    category: "1800s",
    question: "The Civil War had many important events. Name one.",
    answer: "(Battle of) Fort Sumter; Emancipation Proclamation; (Battle of) Vicksburg; (Battle of) Gettysburg; Sherman's March; (Surrender at) Appomattox; (Battle of) Antietam/Sharpsburg; Lincoln was assassinated",
    alternativeAnswers: ["Battle of Fort Sumter", "Emancipation Proclamation", "Battle of Vicksburg", "Battle of Gettysburg", "Sherman's March", "Surrender at Appomattox", "Battle of Antietam", "Lincoln was assassinated"]
  },
  {
    id: 94,
    category: "1800s",
    question: "Abraham Lincoln is famous for many things. Name one.",
    answer: "Freed the slaves (Emancipation Proclamation); Saved (or preserved) the Union; Led the United States during the Civil War; 16th president of the United States; Delivered the Gettysburg Address",
    alternativeAnswers: ["Freed the slaves", "Emancipation Proclamation", "Saved the Union", "Led the United States during the Civil War", "16th president", "Delivered the Gettysburg Address"],
    specialConsideration: true // 65/20 special consideration question
  },
  {
    id: 95,
    category: "1800s",
    question: "What did the Emancipation Proclamation do?",
    answer: "Freed the slaves; Freed slaves in the Confederacy; Freed slaves in the Confederate states; Freed slaves in most Southern states",
    alternativeAnswers: ["Freed the slaves", "Freed slaves in the Confederacy", "Freed slaves in the Confederate states", "Freed slaves in most Southern states"]
  },
  {
    id: 96,
    category: "1800s",
    question: "What U.S. war ended slavery?",
    answer: "The Civil War",
    alternativeAnswers: ["Civil War", "The Civil War"]
  },
  {
    id: 97,
    category: "1800s",
    question: "What amendment says all persons born or naturalized in the United States, and subject to the jurisdiction thereof, are U.S. citizens?",
    answer: "14th Amendment",
    alternativeAnswers: ["14th Amendment", "Fourteenth Amendment"]
  },
  {
    id: 98,
    category: "1800s",
    question: "When did all men get the right to vote?",
    answer: "After the Civil War; During Reconstruction; (With the) 15th Amendment; 1870",
    alternativeAnswers: ["After the Civil War", "During Reconstruction", "15th Amendment", "1870"]
  },
  {
    id: 99,
    category: "1800s",
    question: "Name one leader of the women's rights movement in the 1800s.",
    answer: "Susan B. Anthony; Elizabeth Cady Stanton; Sojourner Truth; Harriet Tubman; Lucretia Mott; Lucy Stone",
    alternativeAnswers: ["Susan B. Anthony", "Elizabeth Cady Stanton", "Sojourner Truth", "Harriet Tubman", "Lucretia Mott", "Lucy Stone"]
  },

  // C: Recent American History and Other Important Historical Information (19 questions)
  {
    id: 100,
    category: "Recent American History",
    question: "Name one war fought by the United States in the 1900s.",
    answer: "World War I; World War II; Korean War; Vietnam War; (Persian) Gulf War",
    alternativeAnswers: ["World War I", "World War II", "Korean War", "Vietnam War", "Persian Gulf War", "Gulf War"]
  },
  {
    id: 101,
    category: "Recent American History",
    question: "Why did the United States enter World War I?",
    answer: "Because Germany attacked U.S. (civilian) ships; To support the Allied Powers (England, France, Italy, and Russia); To oppose the Central Powers (Germany, Austria-Hungary, the Ottoman Empire, and Bulgaria)",
    alternativeAnswers: ["Because Germany attacked U.S. ships", "To support the Allied Powers", "To oppose the Central Powers"]
  },
  {
    id: 102,
    category: "Recent American History",
    question: "When did all women get the right to vote?",
    answer: "1920; After World War I; (With the) 19th Amendment",
    alternativeAnswers: ["1920", "After World War I", "19th Amendment"]
  },
  {
    id: 103,
    category: "Recent American History",
    question: "What was the Great Depression?",
    answer: "Longest economic recession in modern history",
    alternativeAnswers: ["Longest economic recession in modern history"]
  },
  {
    id: 104,
    category: "Recent American History",
    question: "When did the Great Depression start?",
    answer: "The Great Crash (1929); Stock market crash of 1929",
    alternativeAnswers: ["The Great Crash", "1929", "Stock market crash of 1929"]
  },
  {
    id: 105,
    category: "Recent American History",
    question: "Who was president during the Great Depression and World War II?",
    answer: "(Franklin) Roosevelt",
    alternativeAnswers: ["Franklin Roosevelt", "Roosevelt", "FDR"]
  },
  {
    id: 106,
    category: "Recent American History",
    question: "Why did the United States enter World War II?",
    answer: "(Bombing of) Pearl Harbor; Japanese attacked Pearl Harbor; To support the Allied Powers (England, France, and Russia); To oppose the Axis Powers (Germany, Italy, and Japan)",
    alternativeAnswers: ["Bombing of Pearl Harbor", "Japanese attacked Pearl Harbor", "To support the Allied Powers", "To oppose the Axis Powers"]
  },
  {
    id: 107,
    category: "Recent American History",
    question: "Dwight Eisenhower is famous for many things. Name one.",
    answer: "General during World War II; President at the end of (during) the Korean War; 34th president of the United States; Signed the Federal-Aid Highway Act of 1956 (Created the Interstate System)",
    alternativeAnswers: ["General during World War II", "President during the Korean War", "34th president", "Created the Interstate System"]
  },
  {
    id: 108,
    category: "Recent American History",
    question: "Who was the United States' main rival during the Cold War?",
    answer: "Soviet Union; USSR; Russia",
    alternativeAnswers: ["Soviet Union", "USSR", "Russia"]
  },
  {
    id: 109,
    category: "Recent American History",
    question: "During the Cold War, what was one main concern of the United States?",
    answer: "Communism; Nuclear war",
    alternativeAnswers: ["Communism", "Nuclear war"]
  },
  {
    id: 110,
    category: "Recent American History",
    question: "Why did the United States enter the Korean War?",
    answer: "To stop the spread of communism",
    alternativeAnswers: ["To stop the spread of communism"]
  },
  {
    id: 111,
    category: "Recent American History",
    question: "Why did the United States enter the Vietnam War?",
    answer: "To stop the spread of communism",
    alternativeAnswers: ["To stop the spread of communism"]
  },
  {
    id: 112,
    category: "Recent American History",
    question: "What did the civil rights movement do?",
    answer: "Fought to end racial discrimination",
    alternativeAnswers: ["Fought to end racial discrimination"]
  },
  {
    id: 113,
    category: "Recent American History",
    question: "Martin Luther King, Jr. is famous for many things. Name one.",
    answer: "Fought for civil rights; Worked for equality for all Americans; Worked to ensure that people would \"not be judged by the color of their skin, but by the content of their character\"",
    alternativeAnswers: ["Fought for civil rights", "Worked for equality for all Americans", "Worked for equality"],
    specialConsideration: true // 65/20 special consideration question
  },
  {
    id: 114,
    category: "Recent American History",
    question: "Why did the United States enter the Persian Gulf War?",
    answer: "To force the Iraqi military from Kuwait",
    alternativeAnswers: ["To force the Iraqi military from Kuwait"]
  },
  {
    id: 115,
    category: "Recent American History",
    question: "What major event happened on September 11, 2001 in the United States?",
    answer: "Terrorists attacked the United States; Terrorists took over two planes and crashed them into the World Trade Center in New York City; Terrorists took over a plane and crashed into the Pentagon in Arlington, Virginia; Terrorists took over a plane originally aimed at Washington, D.C., and crashed in a field in Pennsylvania",
    alternativeAnswers: ["Terrorists attacked the United States", "9/11", "September 11 attacks"],
    specialConsideration: true // 65/20 special consideration question
  },
  {
    id: 116,
    category: "Recent American History",
    question: "Name one U.S. military conflict after the September 11, 2001 attacks.",
    answer: "(Global) War on Terror; War in Afghanistan; War in Iraq",
    alternativeAnswers: ["War on Terror", "War in Afghanistan", "War in Iraq"]
  },
  {
    id: 117,
    category: "Recent American History",
    question: "Name one American Indian tribe in the United States.",
    answer: "Apache; Blackfeet; Cayuga; Cherokee; Cheyenne; Chippewa; Choctaw; Creek; Crow; Hopi; Huron; Inupiat; Lakota; Mohawk; Mohegan; Navajo; Oneida; Onondaga; Pueblo; Seminole; Seneca; Shawnee; Sioux; Teton; Tuscarora",
    alternativeAnswers: ["Apache", "Blackfeet", "Cayuga", "Cherokee", "Cheyenne", "Chippewa", "Choctaw", "Creek", "Crow", "Hopi", "Huron", "Inupiat", "Lakota", "Mohawk", "Mohegan", "Navajo", "Oneida", "Onondaga", "Pueblo", "Seminole", "Seneca", "Shawnee", "Sioux", "Teton", "Tuscarora"]
  },
  {
    id: 118,
    category: "Recent American History",
    question: "Name one example of an American innovation.",
    answer: "Light bulb; Automobile (cars, internal combustion engine); Skyscrapers; Airplane; Assembly line; Landing on the moon; Integrated circuit (IC)",
    alternativeAnswers: ["Light bulb", "Automobile", "Skyscrapers", "Airplane", "Assembly line", "Landing on the moon", "Integrated circuit"]
  },

  // A: Symbols (5 questions)
  {
    id: 119,
    category: "Symbols",
    question: "What is the capital of the United States?",
    answer: "Washington, D.C.",
    alternativeAnswers: ["Washington, D.C.", "Washington D.C.", "Washington DC"]
  },
  {
    id: 120,
    category: "Symbols",
    question: "Where is the Statue of Liberty?",
    answer: "New York (Harbor); Liberty Island [Also acceptable are New Jersey, near New York City, and on the Hudson (River).]",
    alternativeAnswers: ["New York Harbor", "Liberty Island", "New Jersey", "near New York City", "on the Hudson River"]
  },
  {
    id: 121,
    category: "Symbols",
    question: "Why does the flag have 13 stripes?",
    answer: "(Because there were) 13 original colonies; (Because the stripes) represent the original colonies",
    alternativeAnswers: ["Because there were 13 original colonies", "Because the stripes represent the original colonies"]
  },
  {
    id: 122,
    category: "Symbols",
    question: "Why does the flag have 50 stars?",
    answer: "(Because there is) one star for each state; (Because) each star represents a state; (Because there are) 50 states",
    alternativeAnswers: ["Because there is one star for each state", "Because each star represents a state", "Because there are 50 states"]
  },
  {
    id: 123,
    category: "Symbols",
    question: "What is the name of the national anthem?",
    answer: "The Star-Spangled Banner",
    alternativeAnswers: ["The Star-Spangled Banner"]
  },
  {
    id: 124,
    category: "Symbols",
    question: "The Nation's first motto was \"E Pluribus Unum.\" What does that mean?",
    answer: "Out of many, one; We all become one",
    alternativeAnswers: ["Out of many, one", "We all become one"]
  },

  // B: Holidays (4 questions)
  {
    id: 125,
    category: "Holidays",
    question: "What is Independence Day?",
    answer: "A holiday to celebrate U.S. independence (from Britain); The country's birthday",
    alternativeAnswers: ["A holiday to celebrate U.S. independence", "The country's birthday"]
  },
  {
    id: 126,
    category: "Holidays",
    question: "Name three national U.S. holidays.",
    answer: "New Year's Day; Martin Luther King, Jr. Day; Presidents Day (Washington's Birthday); Memorial Day; Independence Day; Labor Day; Columbus Day; Veterans Day; Thanksgiving Day; Christmas Day",
    alternativeAnswers: ["New Year's Day", "Martin Luther King, Jr. Day", "Presidents Day", "Memorial Day", "Independence Day", "Labor Day", "Columbus Day", "Veterans Day", "Thanksgiving Day", "Christmas Day"]
  },
  {
    id: 127,
    category: "Holidays",
    question: "What is Memorial Day?",
    answer: "A holiday to honor soldiers who died in military service",
    alternativeAnswers: ["A holiday to honor soldiers who died in military service"]
  },
  {
    id: 128,
    category: "Holidays",
    question: "What is Veterans Day?",
    answer: "A holiday to honor people in the (U.S.) military; A holiday to honor people who have served (in the U.S. military)",
    alternativeAnswers: ["A holiday to honor people in the military", "A holiday to honor people who have served in the military"]
  }
];

export const questionsByCategory = {
  "Principles of American Government": naturalizationQuestions.filter(q => q.category === "Principles of American Government"),
  "System of Government": naturalizationQuestions.filter(q => q.category === "System of Government"),
  "Rights and Responsibilities": naturalizationQuestions.filter(q => q.category === "Rights and Responsibilities"),
  "Colonial Period and Independence": naturalizationQuestions.filter(q => q.category === "Colonial Period and Independence"),
  "1800s": naturalizationQuestions.filter(q => q.category === "1800s"),
  "Recent American History": naturalizationQuestions.filter(q => q.category === "Recent American History"),
  "Symbols": naturalizationQuestions.filter(q => q.category === "Symbols"),
  "Holidays": naturalizationQuestions.filter(q => q.category === "Holidays")
};

// Special consideration questions for 65/20 rule
export const specialConsiderationQuestions = naturalizationQuestions.filter(q => q.specialConsideration);

export const getRandomQuestions = (count = 20) => {
  const shuffled = [...naturalizationQuestions].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};

export const getQuestionsWithMultipleChoice = (questions) => {
  return questions.map(question => ({
    ...question,
    multipleChoice: generateMultipleChoiceOptions(question, naturalizationQuestions)
  }));
};

export const searchQuestions = (searchTerm) => {
  const term = searchTerm.toLowerCase().trim();
  if (!term) return naturalizationQuestions;
  
  return naturalizationQuestions.filter(q => {
    // Search in question text
    const questionMatch = q.question.toLowerCase().includes(term);
    
    // Search in answer text
    const answerMatch = q.answer.toLowerCase().includes(term);
    
    // Search in category
    const categoryMatch = q.category.toLowerCase().includes(term);
    
    // Search in alternative answers
    const alternativeMatch = q.alternativeAnswers.some(alt => 
      alt.toLowerCase().includes(term)
    );
    
    // Return true if any field matches
    return questionMatch || answerMatch || categoryMatch || alternativeMatch;
  });
};

// Generate multiple choice options for each question
const generateMultipleChoiceOptions = (question, allQuestions) => {
  const correctAnswers = question.alternativeAnswers;
  const correctAnswer = correctAnswers[0]; // Use the first alternative as the main correct answer
  
  // Generate wrong answers from other questions or common wrong answers
  const wrongAnswers = [];
  
  // Add some generic wrong answers based on question type
  if (question.question.toLowerCase().includes('how many')) {
    const numbers = ['50', '100', '435', '27', '13', '2', '4', '6', '8', '10'];
    wrongAnswers.push(...numbers.filter(n => !correctAnswers.some(ca => ca.includes(n))));
  } else if (question.question.toLowerCase().includes('who')) {
    const people = ['George Washington', 'Thomas Jefferson', 'Abraham Lincoln', 'Franklin Roosevelt', 'John Adams', 'Benjamin Franklin'];
    wrongAnswers.push(...people.filter(p => !correctAnswers.some(ca => ca.includes(p.split(' ')[1]))));
  } else if (question.question.toLowerCase().includes('when')) {
    const dates = ['1776', '1787', '1865', '1920', '1929', '1941', '2001'];
    wrongAnswers.push(...dates.filter(d => !correctAnswers.some(ca => ca.includes(d))));
  } else if (question.question.toLowerCase().includes('what war') || question.question.toLowerCase().includes('name one war')) {
    const wars = ['Civil War', 'World War I', 'World War II', 'Korean War', 'Vietnam War', 'Revolutionary War'];
    wrongAnswers.push(...wars.filter(w => !correctAnswers.some(ca => ca.toLowerCase().includes(w.toLowerCase()))));
  } else {
    // Generic wrong answers
    const generic = [
      'The President', 'Congress', 'Supreme Court', 'Constitution', 'Bill of Rights',
      'Declaration of Independence', 'First Amendment', 'Legislative Branch', 'Executive Branch', 'Judicial Branch'
    ];
    wrongAnswers.push(...generic.filter(g => !correctAnswers.some(ca => ca.toLowerCase().includes(g.toLowerCase()))));
  }
  
  // If we don't have enough wrong answers, get some from other questions
  if (wrongAnswers.length < 3) {
    const otherAnswers = allQuestions
      .filter(q => q.id !== question.id)
      .map(q => q.alternativeAnswers[0])
      .filter(a => a.length < 50); // Keep answers reasonably short
    
    wrongAnswers.push(...otherAnswers.slice(0, 3 - wrongAnswers.length));
  }
  
  // Create multiple choice options (A, B, C, D)
  const options = [correctAnswer, ...wrongAnswers.slice(0, 3)];
  
  // Shuffle the options
  const shuffledOptions = options.sort(() => 0.5 - Math.random());
  
  return {
    options: shuffledOptions,
    correctAnswer: correctAnswer,
    correctIndex: shuffledOptions.indexOf(correctAnswer)
  };
};
export const speakText = (text) => {
  if ('speechSynthesis' in window) {
    // Cancel any ongoing speech
    window.speechSynthesis.cancel();
    
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.rate = 0.8; // Slightly slower for clarity
    utterance.pitch = 1;
    utterance.volume = 1;
    
    // Try to use a more natural voice
    const voices = window.speechSynthesis.getVoices();
    const preferredVoice = voices.find(voice => 
      voice.lang.startsWith('en') && 
      (voice.name.includes('Natural') || voice.name.includes('Google') || voice.name.includes('Samantha'))
    );
    
    if (preferredVoice) {
      utterance.voice = preferredVoice;
    }
    
    window.speechSynthesis.speak(utterance);
    return utterance;
  } else {
    console.warn('Speech synthesis not supported in this browser');
    return null;
  }
};

export const stopSpeaking = () => {
  if ('speechSynthesis' in window) {
    window.speechSynthesis.cancel();
  }
};

export const isSpeaking = () => {
  return 'speechSynthesis' in window && window.speechSynthesis.speaking;
};